const styles = {
  wrapper: {
    position: 'relative',
    animation: 'flicker 4.2s linear infinite',
  },
  scanlines: {
    position: 'absolute',
    inset: 0,
    background: 'repeating-linear-gradient(0deg, transparent 0px, transparent 2px, rgba(0,0,0,0.15) 2px, rgba(0,0,0,0.15) 4px)',
    pointerEvents: 'none',
    zIndex: 50,
  },
};

export default function CRTWrapper({ children, style }) {
  return (
    <div style={{ ...styles.wrapper, ...style }}>
      {children}
      <div style={styles.scanlines} />
    </div>
  );
}
